import { DefaultConfig } from './_LayoutConfig';
import { type ILayout } from './_Models';

/**
 * Layout configuration for System Users.
 * Based on the default dark-sidebar layout with standard navigation.
 */

export const SystemUserLayoutConfig: ILayout = {
  ...DefaultConfig,
  layoutType: 'dark-sidebar',
  app: {
    ...DefaultConfig.app,
    pageTitle: {
      ...DefaultConfig.app?.pageTitle,
      display: true,
      direction: 'column',
      class: 'my-3',
    },
  },
};
